import { useThree, useFrame } from '@react-three/fiber';

const MouseMoveHelper = ({ group, coinIsTossed }) => {
  const { viewport } = useThree();

  useFrame(({ mouse }) => {
    if (group.current) {
      let rotationYTarget = ((mouse.x - viewport.width / 2) / viewport.width) * Math.PI * 0.6 - Math.PI * 0.3;
      let rotationXTarget = ((mouse.y + viewport.height / 2) / viewport.height) * Math.PI * 0.6 - Math.PI * 0.3;

      if (coinIsTossed === true) {
        rotationXTarget = 0;
        rotationYTarget = group.current.rotation.y;
      }

      group.current.rotation.y += (rotationYTarget - group.current.rotation.y) * 0.2;
      group.current.rotation.x += (rotationXTarget - group.current.rotation.x) * 0.2;
    }
  });

  return null;
}

export default MouseMoveHelper;